import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import type { Room_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { ToastAction } from "@/components/ui/toast/toast";

import * as Shared from "../../../../../_shared";
import { useRoomArticleUpdateMutation } from "../../repository/mutation/use-room-article-update-mutation";

type Props = {
	hotelID: string;
	roomID: string;
	serverModel: Room_DesignPageQuery;
};

export const useInitialized = ({ hotelID, roomID, serverModel }: Props) => {
	const { onUpdate: _onUpdate } = useRoomArticleUpdateMutation({ hotelID, roomID });
	const { article, tags, tagsLocation } = serverModel.room;

	const navigate = useNavigate();
	const roomListPath = generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.ROOM, { hotelID });

	const onNavigateToRoomList = useCallback(() => {
		navigate(roomListPath);
	}, [roomListPath, navigate]);

	const onUpdateSuccessCallback = useCallback(() => {
		notifyUserEventInfo({
			title: "ルーム記事を保存しました",
			action: (
				<ToastAction onClick={onNavigateToRoomList} altText="一覧に戻る">
					一覧に戻る
				</ToastAction>
			),
		});
	}, [onNavigateToRoomList]);

	const { articleHTML, onSetArticleHTML, tag, onSetTag, isDirty, isValid, onUpdate } =
		Shared.Model.UseCase.useCreateMagazineEditorForDefaultModel({
			article,
			tagList: tags,
			/**
			 * tagsLocation の index は以下の定義順となっている
			 */
			regionTag: tagsLocation[0],
			prefectureTag: tagsLocation[1],
			cityTag: tagsLocation[2],
			onUpdate: _onUpdate,
			onUpdateSuccessCallback,
		});

	return {
		serverModel,
		articleHTML,
		onSetArticleHTML,
		tag,
		onSetTag,
		isDirty,
		isValid,
		onUpdate,
	};
};
